module.exports = "<div class=background></div><div layout=column layout-align=\"center center\" class=loading-wrapper><div class=loading></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./js/theme/loading/view.html
 ** module id = 403
 ** module chunks = 0
 **/